export const config = (theirMonthOffer, discountDuration, secondBoxDiscount) => ({
  youGetTitle: 'You get',
  yourFriendGetsTitle: 'Your friend gets',
  youGetDescription: 'when their first order is delivered',
  yourFriendGetsDescription: `off their first box + ${secondBoxDiscount} off their 2nd box + ${theirMonthOffer} off their first ${discountDuration}`,
})
